<div [ngSwitch]="type">
<ng-container *ngSwitchDefault>
	<div [style.min-height]="minHeight" class="custom-layer">
		<div>
			<ng-container *ngTemplateOutlet="header"></ng-container>
			<ng-container *ngTemplateOutlet="content"></ng-container>
		</div>
		<div>
			<ng-container *ngTemplateOutlet="footer"></ng-container>
		</div>
	</div>
</ng-container>
<ng-container *ngSwitchCase="'version2'">
	<div [style.min-height]="hasContentFooter? minHeight: ''" 
	[ngClass]="{'min-h-screen':!hasContentFooter}"
	  class="flex flex-col">
		<div class="grow flex flex-col">
			<div *ngIf="!hasContentFooter" class="{{headerClass}}">
			 <ng-container *ngTemplateOutlet="header"></ng-container>
			</div>
			<div class="grow {{contentClass}}">
				<ng-container *ngTemplateOutlet="content"></ng-container>
			</div>
			<div>
				<ng-content select="[content-footer]"></ng-content>
			</div>
		</div>
		<div class="{{footerClass}}">
			<ng-container *ngTemplateOutlet="footer"></ng-container>
		</div>
	</div>
</ng-container>
</div>

<ng-template #header>
<ng-content select="[header]"></ng-content>
</ng-template>
<ng-template #content>
	<ng-content select="[content]"></ng-content>
</ng-template>
<ng-template #footer>
	<ng-content select="[footer]"></ng-content>
</ng-template>



